// extracted by mini-css-extract-plugin
module.exports = {"modal-scroll":"Alpha_modal-scroll__O2rsW","alphaArea":"Alpha_alphaArea__vGqXs","alphaGradient":"Alpha_alphaGradient__TW04h"};